import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Box, CssBaseline, ThemeProvider } from '@mui/material'
import theme from 'theme'
import { SnackbarProvider } from 'contexts/SnackbarContext'
import { AuthProvider } from 'contexts/AuthContext'
import { CartProvider } from 'contexts/CartContext'
import { PaymentProvider } from 'contexts/PaymentContext'
import Layout from 'components/Layout'
import { LoadingProvider } from 'contexts/LoadingContext'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider>
          <LoadingProvider>
            <BrowserRouter>
              <AuthProvider>
                <CartProvider>
                  <PaymentProvider>
                    <Box sx={{ minWidth: 1440 }}>
                      <Layout />
                    </Box>
                  </PaymentProvider>
                </CartProvider>
              </AuthProvider>
            </BrowserRouter>
          </LoadingProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </I18nextProvider>
  )
}

export default App
